/**
 * Element id of the supplier detail page's scroll container (`SupplierDetailLayout`). The page
 * scrolls inside this box, not the window, so infinite-scroll lists in a tab pass it as their
 * `scrollableTarget`.
 */
export const SUPPLIER_DETAIL_SCROLL_ID = 'supplier-detail-scroll';

/**
 * Where content inside a tab can stick so it sits directly under the layout's own sticky header:
 * the back-button bar (sticky at `top: 0`) and the tab bar (sticky at `top: 62`, ~51px tall
 * including its 16px bottom padding). Update together with `SupplierDetailLayout` if either moves.
 */
export const SUPPLIER_DETAIL_STICKY_TOP = 112;
